// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2480) return "static/chunks/2480.2dc8c88f57ce68e9.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"249":"b2d98e07","7282":"7064611b","7448":"ff804112"}[chunkId] || chunkId) + "-" + {"249":"9d5b09c3ef4e0752","3614":"e57bae94d570c073","6403":"c43cc8afd407f994","7282":"48c1a024ee2083aa","7448":"32c7f79181de4156"}[chunkId] + ".js";
};